export default __webpack_public_path__ + "static/google_play-35574f268cc28d14ef9c31cac02ac420.png";